import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import HelpTooltip from "./HelpTooltip";
import { LocalStorageKeyConstants } from "../../constants";

/**
 * Komponent logowania
 *
 * @component
 * @returns
 */
function TFLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [step, setStep] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const { login_step1, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (step === 2) {
      const timeoutId = setTimeout(() => {
        const redirectPath = localStorage.getItem(
          LocalStorageKeyConstants.REDIRECT_PATH
        );

        if (redirectPath) {
          localStorage.removeItem(LocalStorageKeyConstants.REDIRECT_PATH);
          navigate(redirectPath, { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
  }, [step, navigate]);

  /**
   * Funkcja obsługująca wystąpienie płędu w formularzu
   *
   * @function
   * @returns {void}
   */
  const onError = () => {
    setShowAlert(true);
    setStep(0);
  };

  /**
   * Funcka obsługująca poprawne przesłanie formularza
   *
   * @function
   * @returns {void}
   */
  const onSuccess = () => {
    setStep(2);
  };

  /**
   * Funkcja obsługująca przesłanie formularza
   *
   * @function
   * @param {Event} e - Event
   * @returns {void}
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (step === 0 || step === 3) {
      const loginStep1Result = await login_step1(username);

      if (loginStep1Result) {
        setStep(1);
      } else {
        onError();
      }
    } else {
      const dane = await login(username, password);
      if (dane) {
        onSuccess();
      } else {
        onError();
      }
    }
  };

  switch (step) {
    case 1:
      return (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Adres e-mail</label>
            <input
              type="text"
              className="form-control mb-2 h2 rounded-3"
              value={username}
              disabled
            />
            <label className="form-label">
              Hasło jednorazowe otrzymane e-mailem
            </label>
            <input
              type="text"
              className="form-control mb-2 h2 rounded-3"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="hasło"
            />
            <button
              type="submit"
              className="btn btn-primary h2 mb-2 rounded-3 w-100"
            >
              Zaloguj
            </button>
          </div>
        </form>
      );

    case 2:
      return (
        <div className="alert alert-success fade show" role="alert">
          <div className="d-flex flex-row">
            <div>
              <strong>Zalogowano pomyślnie</strong>
              <br />
              Za chwilę nastąpi przekierowanie do systemu.
            </div>
            <div className="ms-auto spinner-border" role="status">
              <span className="visually-hidden">...</span>
            </div>
          </div>
        </div>
      );

    default:
      return (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            {showAlert && (
              <div
                className="alert alert-warning alert-dismissible d-flex align-items-center fade show"
                role="alert"
              >
                <div>
                  <strong>Błąd logowania</strong>
                  <br />
                  Sprawdź poprawność danych do logowania.
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowAlert(false)}
                  aria-label="Close"
                ></button>
              </div>
            )}
            <div className="d-flex flex-row">
              <label className="form-label">Adres e-mail</label>
              <HelpTooltip
                title="Na podany adres e-mail otrzymasz jednorazowe hasło."
                wide={true}
              />
            </div>
            <input
              type="email"
              className="form-control mb-2 h2 rounded-3"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="email@domena.pl"
              required
            />
            <button type="submit" className="btn btn-lg w-100 btn-primary mb-1">
              Dalej
            </button>
            <div className="d-flex flex-column">
              <div className="d-flex justify-content-center">
                Nie masz konta?&nbsp;<a href="/Register">Zarejestruj się</a>
              </div>
              <div className="d-flex justify-content-center">
                <a
                  href="/dokumenty/Regulamin_serwisu_eCO-wazny_od_06-05-2025.pdf"
                  target="_blank"
                >
                  Regulamin serwisu
                </a>
              </div>
            </div>
          </div>
        </form>
      );
  }
}

export default TFLogin;
